var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.58579C0 5.0335 0.447715 4.58579 1 4.58579H12C12.5523 4.58579 13 5.0335 13 5.58579V6.58579C13 7.13807 12.5523 7.58579 12 7.58579H1C0.447715 7.58579 0 7.13807 0 6.58579V5.58579Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32606 0.292893C9.71658 -0.097631 10.3497 -0.0976311 10.7403 0.292893L15.9707 5.52335C16.3613 5.91388 16.3613 6.54704 15.9707 6.93757L15.2866 7.62167C14.8961 8.01219 14.2629 8.01219 13.8724 7.62167L8.64195 2.39121C8.25143 2.00069 8.25143 1.36752 8.64195 0.976997L9.32606 0.292893Z",
    fill: "#FBFBFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9707 5.52335C16.3613 5.91388 16.3613 6.54704 15.9707 6.93757L10.7402 12.1684C10.3497 12.5589 9.71653 12.5589 9.326 12.1684L8.6419 11.4843C8.25138 11.0937 8.25138 10.4606 8.6419 10.07L13.8724 4.83958C14.2629 4.44906 14.896 4.44906 15.2866 4.83958L15.9707 5.52335Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forward-arrow.94cd400b74af1e3333705ff337724a28.svg";
export { ForwardRef as ReactComponent };